// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_37-1";
export var movingGradient = "_37-4";
export var movingGradientBlock = "_37-2";
export var skeleton = "_37-0";
export var skeletonText = "_37-3";